import React from 'react';
import { Link } from 'react-router-dom';

import { pushIconClick } from '@app/components/TagManager';
import { LinkBlockItemIcon } from '@app/objects/LinkBlockItem';
import '@app/scss/components/linkBlockIcons.scss';

interface LinkBlockIconsProps {
	items: Array<LinkBlockItemIcon>;
}

const LinkBlockIcons: React.FC<LinkBlockIconsProps> = ({ items }) => (
	<div className="link-block-icons">
		{items.map((item, index) => (
			<div className="link-block-icon-wrapper" key={item.path + index} onClick={() => pushIconClick(item.id)}>
				<div className="link-block-icon-wrapper__helper" />
				<Link className="link-block-icon" to={item.path}>
					<div className="link-block-icon__icon">
						<img className={`link-block-icon__icon-img ${item?.className || ''}`} src={item.src} alt={item.alt || ''} />
					</div>
					<h5 className="link-block-icon__title">{item.name}</h5>
				</Link>
			</div>
		))}
	</div>
);

export default LinkBlockIcons;
